module.exports = __webpack_public_path__ + "img/info.5112eb3c.png";